module.exports = __webpack_public_path__ + "img/ENGIE.3612d7f9.png";